<div class="pivot-confirm-dialog-container">
  <div *ngIf="isDisplayHeader" class="header-dialog-custom">
    <div class="header-dialog-custom-title">{{ title | translate }}</div>
    <div class="btn-close-right" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </div>
  </div>
  <div class="content-dialog-custom">
    <div
      *ngIf="!useInnerHTML"
      class="message d-flex justify-content-center align-items-center mb-3"
      [class.text-left]="messageLeft"
    >
      {{ message | translate }}
    </div>
    <div
      *ngIf="useInnerHTML"
      class="message d-flex justify-content-center align-items-center mb-3"
      [class.text-left]="messageLeft"
      [innerHTML]="message | translate"
    ></div>

    <div mat-dialog-actions>
      <div class="d-flex align-items-center mb-3 btn-confirm-dlg">
        <button mat-flat-button type="button" [ngClass]="{'btn-custom-style1': type != 0, 'btn-custom-style2': type == 0}" (click)="onDismiss()">
          {{ cancelButtonText | translate }}
        </button>
        <button *ngIf="type === 1" mat-flat-button type="button" class="btn-custom-style2" cdkFocusInitial (click)="onConfirm()">
          OK
        </button>
      </div>
    </div>
  </div>
</div>
